import { Component, ElementRef, Input, ViewChild } from '@angular/core';
import { EventCarouselInterface } from './interfaces/event-carousel.interface';
declare var $: any;
@Component({
  selector: 'tic-event-carousel',
  templateUrl: './event-carousel.component.html',
  styleUrls: ['./event-carousel.component.scss']
})
export class EventCarouselComponent {
  @Input() itemList!: EventCarouselInterface[];
  @ViewChild('events') events: ElementRef;

  ngAfterViewInit() {
    this.initializeSlider();
    $(window).on('resize', () => this.initializeSlider());
  }

  private initializeSlider() {
    const width = $("body").width();
    if (width > 767) {
      // Check if slick is not initialized to prevent reinitialization
      if (!$(this.events.nativeElement).hasClass('slick-initialized')) {
        $(this.events.nativeElement).slick({
          slidesToShow: 3,
          slidesToScroll: 1,
          arrows: true,
          centerMode: true,
          centerPadding: "0",
          responsive: [
            {
              breakpoint: 1280,
              settings: {
                slidesToShow: 3,
                slidesToScroll: 1,
              },
            },
            {
              breakpoint: 800,
              settings: {
                slidesToShow: 2,
                slidesToScroll: 1,
                arrows: false,
              },
            },
          ],
        });
      }
    } else {
      // Destroy the slider if initialized
      if ($(this.events.nativeElement).hasClass('slick-initialized')) {
        $(this.events.nativeElement).slick('unslick');
      }
    }
  }
}
